export const blocksConfig = {
    backend: 'backend',
    public: 'public',
    styles: 'styles',
    pages: {
        structure: {
            code: 'index.js',
            document: {
                structure: 'structure.xml',
                data: 'data.json',
                style: 'style.wcss'
            }
        },
        folders: {
            Page: [
                { name: 'pages', type: 'Folder' },
                { variableName: 'title', type: 'DynamicFolder' }
            ],
            Dashboard: [
                { name: 'dashboards', type: 'Folder' },
                { variableName: 'dashboardName', type: 'DynamicFolder' }
            ],
            Widget: [
                { name: 'widgets', type: 'Folder' },
                { variableName: 'widgetName', type: 'DynamicFolder' }
            ],
            Panel: [
                { name: 'widgets', type: 'Folder' },
                { variableName: 'widgetName', type: 'DynamicFolder' },
                { name: 'panels', type: 'Folder' },
                { variableName: 'panelName', type: 'DynamicFolder' }
            ]
        }
    }
};
